// modules
import { handleActions } from 'redux-actions'

// utils
import {
  setProgramReportList,
  resetProgramReport
} from 'src/store/modules/reports/programReport'

const initialState = []

export default handleActions(
  {
    [setProgramReportList](_, { payload: programReportList }) {
      return programReportList
    },

    [resetProgramReport]() {
      return initialState
    }
  },
  initialState
)
